import { createSlice } from "@reduxjs/toolkit";

export enum VehicleTypeCode {
  Arctic = "arctic",
  ArcticEmpty = "arctic_empty",
  Trailer = "trailer",
  TrailerEmpty = "trailer_empty",
  OnlyTruck = "only_truck",
  Other = "other",
}

export type VehicleType = {
  id: number;
  code: VehicleTypeCode;
  name: string;
};

type InitialState = {
  data: VehicleType[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const vehicleTypeSlice = createSlice({
  name: "vehicleTypeSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default vehicleTypeSlice;
